import { renderBoldWrapper } from 'components/table/renders';
import { boldTitleWrapper, renderPlayersCount, renderRateLink, renderRateTitle, renderTime } from './renders';

import type { ITableColumn } from 'utils/table/types';
import type { IRate } from 'modules/api-requests/rates/types';
import type { ITeeTime } from 'modules/api-requests/tee-time/types';

type GetTeeTimeColumnsType = (rateNames?: IRate[]) => ITableColumn<ITeeTime>[];

export const getTeeTimeColumns: GetTeeTimeColumnsType = (rates = [] as IRate[]) => [
  {
    title: boldTitleWrapper('Time'),
    dataIndex: 'startTime',
    key: 'startTime',
    width: rates.length > 4 ? 130 : 140,
    fixed: 'left',
    render: renderBoldWrapper(renderTime),
  },
  {
    title: boldTitleWrapper('Players'),
    dataIndex: 'allowedSlots',
    key: 'allowedSlots',
    width: rates.length > 4 ? 80 : 120,
    fixed: 'left',
    render: renderBoldWrapper(renderPlayersCount),
  },
  ...rates.map((rate) => ({
    title: renderRateTitle(rate),
    dataIndex: ['rates', rate.id, 'price'],
    key: 'rates',
    width: rates.length > 4 ? 130 : 'auto',
    render: renderBoldWrapper(renderRateLink(rate.id)),
  })),
];

